export const sessionDetails = {
    sessionDetails: [
        {
            id: 'f11f7d2e-e1d0-4d5f-a20d-1c94a24063a5',
            ipAddress: '154.61.65.189',
            accessType:
                'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6 Safari/605.1.15',
            creationTime: '1660274175',
            lastAccessedTime: '1660274180'
        },
        {
            id: 'd22f7c1a-e1d0-4d5f-a20d-1c94a24064ac',
            ipAddress: '154.61.65.189',
            accessType:
                'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6 Safari/605.1.15',
            creationTime: '1660274175',
            lastAccessedTime: '1660274180'
        }
    ]
};
